var map = {
	"./Drinks_Coke.png": 8192,
	"./apple_pie_roll.png": 2375,
	"./beijing_beef.png": 5779,
	"./blazing.png": 1203,
	"./blazing2.png": 1449,
	"./blazing3.png": 6624,
	"./bottled_water.png": 5058,
	"./bourbon_chicken.png": 4207,
	"./broccoli_beef.png": 6856,
	"./cc_rangoon.png": 6517,
	"./chef_special.png": 7472,
	"./chow_mein.png": 6588,
	"./egg_roll.png": 3147,
	"./fountain_drink.png": 9687,
	"./fried_rice.png": 8178,
	"./gatorade.png": 6133,
	"./kung_pao_chicken.png": 6200,
	"./mushroom_chicken.png": 218,
	"./orange_chicken.png": 902,
	"./pepper_chicken.png": 9072,
	"./pepper_steak.png": 3183,
	"./sesame_chicken.png": 6326,
	"./spring_roll.png": 3145,
	"./string_bean_chicken.png": 2826,
	"./super_greens_entree.png": 8972,
	"./super_greens_side.png": 6676,
	"./sweetfire_chicken.png": 2054,
	"./teriyaki_chicken.png": 1360,
	"./walnut_shrimp.png": 6127,
	"./white_rice.png": 9821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3427;